import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { fetchReservationOrderedItemsReport as fetchReservationOrderedItemsReportRoutine } from './routines';

export const fetchReservationOrderedItemsReport = ({ payload: body }) =>
  sagaRoutineRequest(fetchReservationOrderedItemsReportRoutine, {
    request: () => call(Api.fetchReservationOrderedItemsReport, body)
  });
